module.exports = __webpack_public_path__ + "img/loanitem.669edc3f.svg";